import React, { memo } from 'react';
/* Constants */
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';
/* Components */
import { GlobalSearchThumbnail } from 'site-modules/shared/components/inventory/global-search/global-search-thumbnail/global-search-thumbnail';
import { BaseGlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/base-global-search-link';

export const CoreGlobalSearchLink = memo(
  ({
    query = GlobalSearchLinkDefaultProps.query,
    creativeId = GlobalSearchLinkDefaultProps.creativeId,
    isMobile = GlobalSearchLinkDefaultProps.isMobile,
    onLinkClick = GlobalSearchLinkDefaultProps.onLinkClick,
    url = GlobalSearchLinkDefaultProps.url,
    selectionType = GlobalSearchLinkDefaultProps.selectionType,
    title = GlobalSearchLinkDefaultProps.title,
    rel = GlobalSearchLinkDefaultProps.rel,
    fastMatcherData = GlobalSearchLinkDefaultProps.fastMatcherData,
    icon = GlobalSearchLinkDefaultProps.icon,
    label = GlobalSearchLinkDefaultProps.label,
    linkType = GlobalSearchLinkDefaultProps.linkType,
    ...restProps
  }) => {
    return (
      <BaseGlobalSearchLink
        linkThumbComponent={GlobalSearchThumbnail}
        {...restProps}
        query={query}
        creativeId={creativeId}
        isMobile={isMobile}
        onLinkClick={onLinkClick}
        url={url}
        selectionType={selectionType}
        title={title}
        rel={rel}
        fastMatcherData={fastMatcherData}
        icon={icon}
        label={label}
        linkType={linkType}
      />
    );
  }
);

CoreGlobalSearchLink.displayName = 'CoreGlobalSearchLink';

CoreGlobalSearchLink.propTypes = {
  ...GlobalSearchLinkPropTypes,
};
